export const dateMaskPlaceholder = 'mm/dd/yyyy';
export const dateMask = '99/99/9999';
